import React, { Component } from 'react';
import { Button } from 'styled';
import { AiOutlineException } from "react-icons/ai";
import { Tooltip } from '@mui/material';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: {} };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error(error);
    this.state = {
      ...this.state,
      error: error
    }
  }

  render() {
    if (this.state.hasError) {
      return <div className= "flex flex-col gap-4 m-auto h-full h-[100vh] justify-center items-center font-medium text-xl">
       <AiOutlineException 
       className='h-[100px] w-[200px]' color='#00000080'/>
        <Tooltip
        placement="top-end"
        title={this.state.error?.message}>
          Something Went Wrong!
        </Tooltip>
        <button className='text-white bg-green-500 rounded-sm shadow-sm px-2 py-1'
        onClick={()=>window.location.reload()}>
          Try Again
        </button>
      </div>;
    }
    return this.props.children;
  }
}
